import React from "react";
import Marquee from "react-fast-marquee";

const RollingMarquee = ({ text, highlight, symbol1, symbol2,  repeat = 10, speed = 50, direction = "right" }) => {
  return (
    <Marquee speed={speed} direction={direction} gradient={false}>
      {[...Array(repeat)].map((_, i) => (
        <span key={i} style={{ marginRight: "20px" }}>
           {/* {symbol1} {text}   <span style={{ color: "var(--main-bg2)" }}>{highlight}! </span> {symbol2} */}
           {symbol1} {text}    {symbol2}
        </span>
      ))}
    </Marquee>
  );
};

export default RollingMarquee;


 